// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2wtKn","overflowing":"ReadFullNote_overflowing__2IVpp"};